import { makeStyles } from '@material-ui/core';

export const TitledTableCellStyle = makeStyles({
    head: {
        padding: '12px 16px 5px 16px',
    },
});
